/* sort.icon.svg.js */

"use strict";
module.exports = {
    icon: `
        <svg viewBox="0 0 16 16" preserveAspectRatio="none">
            <g>
                <path class="foreground-gl" d="M4.1,5.3h7.8c0.4,0,0.7,0.5,0.4,0.8l-3.9,4.3c-0.2,0.2-0.5,0.2-0.7,0L3.7,6.2C3.4,5.8,3.6,5.3,4.1,5.3z"/>
            </g>
        </svg>`,
    toggledIcon: `
        <svg viewBox="0 0 16 16" preserveAspectRatio="none">
        <g>
            <path class="foreground-gl" d="M11.9,10.7H4.1c-0.4,0-0.7-0.5-0.4-0.8l3.9-4.3c0.2-0.2,0.5-0.2,0.7,0l3.9,4.3C12.6,10.2,12.4,10.7,11.9,10.7z
                "/>
        </g>
        </svg>`,
};
